import React from "react";
import { Link } from "react-router-dom";
const Breadcrumbs = ({btn_name,Page_heading,privious_slug}) => {
    return (
        <>
            <div className="page-header">
                <h1>
                    <button
                        className="btn_5 mt05 float-end"
                        data-bs-toggle="modal"
                        data-bs-target="#addcandidate"
                    >
                        {btn_name}
                    </button>
                    {Page_heading}
                </h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to={`/${privious_slug}`}>{privious_slug}</Link>
                    </li>
                    <li className="current">
                        <span>/</span>{Page_heading}
                    </li>
                </ul>
            </div>
        </>
    )
}
export default Breadcrumbs;